import React, { FC } from 'react';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { AISummaryMode } from '../../interface/sellerInfo';
import { AISummary } from './AISummary';
import { AISummaryPlaceholder } from './AISummaryPlaceholder';

interface AISummaryWrapperProps {
  mode: AISummaryMode;
  summary?: string[];
}

export const AISummaryWrapper: FC<AISummaryWrapperProps> = ({ mode, summary }) => {
  const {
    biankaEvents: { reportAISummaryToggle, reportAISummaryImpression, reportAISummaryControlImpression },
  } = useGigPageContext();

  if (mode === AISummaryMode.IMPRESSION) {
    return <AISummaryPlaceholder onImpression={reportAISummaryControlImpression} />;
  }

  if (mode === AISummaryMode.DISPLAY && summary) {
    return <AISummary summary={summary} onToggle={reportAISummaryToggle} onImpression={reportAISummaryImpression} />;
  }

  return null;
};
